<template>
  <section class="c-project-weekplan-tooltip">
    <p class="text-center u-extra-small-margin--top u-extra-small-margin--bottom">
      <strong>{{ $t('weeks.project.crud.add') }}</strong>
    </p>
    <div v-for="(item, index) in weekplans" :key="index" class="grid-container">
      <v-weekplan-item :item="item" @onRefresh="getWeekplans" />
    </div>

    <button
      class="button button--action button--action--add-project"
      @click.prevent="insertNewItem"
      :title="$t('weeks.project.crud.add')"
    >
      <span>{{ $t('create_new') }}</span>
    </button>
  </section>
</template>

<script>
import ProjectWeekplanItem from "./ProjectWeekplanItem";

export default {
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    projectLayers: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      weekplans: [],
      newWeekplanItem: {
        project_id: this.projectId,
        project_layers: this.projectLayers
      }
    };
  },
  components: {
    vWeekplanItem: ProjectWeekplanItem
  },
  watch: {
    $route: {
      handler: function() {
        this.getWeekplans();
      },
      deep: true
    }
  },
  created: function() {
    this.getWeekplans();
  },

  methods: {
    getWeekplans: function() {
      let promise = this.$api
        .clearParams()
        .addParam("project_id", this.projectId)
        .addParam("sortdir", "asc")
        .get("weekplan");

      return promise
        .then(
          function(response) {
            this.weekplans = response.data.data;
            this.$emit("pushWeekplans", this.weekplans);
          }.bind(this)
        )
        .catch(
          function(error) {
            window.app.$helpers.logger(error.response.data.message);
          }.bind(this)
        );
    },
    insertNewItem: function() {
      this.weekplans.push(this.newWeekplanItem);
    }
  }
};
</script>